var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "AccordionContainer",
        { staticStyle: { border: "0" }, attrs: { multiple: false } },
        [
          Object.keys(_vm.availableLibraryCategories).length
            ? _c("AccordionItem", {
                staticClass: "accordion-select",
                style: _vm.accordionItemStyles,
                attrs: {
                  isOpenByDefault: "",
                  title: _vm.$tr("categoryLabel"),
                  headerAppearanceOverrides: _vm.accordionHeaderStyles(
                    _vm.activeCategories.some((cat) =>
                      _vm.isCategoryActive(cat)
                    )
                  ),
                },
                scopedSlots: _vm._u(
                  [
                    _vm.searchLoading
                      ? {
                          key: "content",
                          fn: function () {
                            return [_c("KCircularLoader")]
                          },
                          proxy: true,
                        }
                      : {
                          key: "content",
                          fn: function () {
                            return [
                              _vm._l(
                                _vm.availableLibraryCategories,
                                function (category, key) {
                                  return _c(
                                    "KButton",
                                    {
                                      key: "cat-" + key,
                                      staticClass: "category-button",
                                      class: _vm.$computedClass({
                                        ":hover": {
                                          background:
                                            _vm.selectedHighlightColor,
                                        },
                                      }),
                                      style: {
                                        background: _vm.isCategoryActive(
                                          category.value
                                        )
                                          ? _vm.selectedHighlightColor
                                          : "",
                                      },
                                      attrs: {
                                        appearance: "flat-button",
                                        text: _vm.coreString(category.value),
                                        disabled:
                                          _vm.availableRootCategories &&
                                          !_vm.availableRootCategories[
                                            category.value
                                          ] &&
                                          !_vm.isCategoryActive(category.value),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleCategory(key)
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "icon",
                                            fn: function () {
                                              return [
                                                _c("KIcon", {
                                                  staticClass: "category-icon",
                                                  attrs: {
                                                    icon: _vm.categoryIcon(key),
                                                    color:
                                                      _vm.$themeTokens.primary,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      category.nested
                                        ? _c("KIcon", {
                                            staticClass: "category-icon-after",
                                            attrs: { icon: "chevronRight" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c("KButton", {
                                staticClass: "category-button",
                                class: _vm.$computedClass({
                                  ":hover": {
                                    background: _vm.selectedHighlightColor,
                                  },
                                }),
                                style: {
                                  background: _vm.isCategoryActive(
                                    "no_categories"
                                  )
                                    ? _vm.selectedHighlightColor
                                    : "",
                                },
                                attrs: {
                                  text: _vm.coreString("otherCategories"),
                                  appearance: "flat-button",
                                },
                                on: { click: _vm.noCategories },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c("KIcon", {
                                            staticClass: "category-icon",
                                            attrs: {
                                              icon: "optionsCircle",
                                              color: _vm.$themeTokens.primary,
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1624068068
                                ),
                              }),
                            ]
                          },
                          proxy: true,
                        },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
          _vm.languageOptionsList.length
            ? _c("AccordionItem", {
                staticClass: "accordion-select",
                style: _vm.accordionItemStyles,
                attrs: {
                  title: _vm.coreString("languageLabel"),
                  headerAppearanceOverrides: _vm.accordionHeaderStyles(
                    _vm.anySelectedFor("languages", _vm.languageOptionsList)
                  ),
                  disabled:
                    _vm.searchLoading ||
                    _vm.languageOptionsList.every((opt) => opt.disabled),
                  contentAppearanceOverrides: {
                    maxHeight: "256px",
                    overflowY: "scroll",
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function () {
                        return _vm._l(_vm.languageOptionsList, function (lang) {
                          return _c("KCheckbox", {
                            key: "lang-" + lang.value,
                            attrs: {
                              checked: _vm.isSelected("languages", lang),
                              disabled: lang.disabled,
                              label: lang.label,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handleChange("languages", lang)
                              },
                            },
                          })
                        })
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1470568823
                ),
              })
            : _vm._e(),
          _vm.contentLevelOptions.length
            ? _c("AccordionItem", {
                staticClass: "accordion-select",
                style: _vm.accordionItemStyles,
                attrs: {
                  title: _vm.coreString("levelLabel"),
                  disabled:
                    _vm.searchLoading ||
                    _vm.contentLevelOptions.every((opt) => opt.disabled),
                  headerAppearanceOverrides: _vm.accordionHeaderStyles(
                    _vm.anySelectedFor("grade_levels", _vm.contentLevelOptions)
                  ),
                  contentAppearanceOverrides: {
                    maxHeight: "256px",
                    overflowY: "scroll",
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function () {
                        return _vm._l(
                          _vm.contentLevelOptions,
                          function (level) {
                            return _c("KCheckbox", {
                              key: "level-" + level.value,
                              attrs: {
                                checked: _vm.isSelected("grade_levels", level),
                                disabled: level.disabled,
                                label: level.label,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChange("grade_levels", level)
                                },
                              },
                            })
                          }
                        )
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1319354410
                ),
              })
            : _vm._e(),
          _vm.accessibilityOptionsList.length
            ? _c("AccordionItem", {
                staticClass: "accordion-select",
                style: _vm.accordionItemStyles,
                attrs: {
                  title: _vm.coreString("accessibility"),
                  headerAppearanceOverrides: _vm.accordionHeaderStyles(
                    _vm.anySelectedFor(
                      "accessibility_labels",
                      _vm.accessibilityOptionsList
                    )
                  ),
                  disabled:
                    _vm.searchLoading ||
                    _vm.accessibilityOptionsList.every((opt) => opt.disabled),
                  contentAppearanceOverrides: {
                    maxHeight: "256px",
                    overflowY: "scroll",
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function () {
                        return _vm._l(
                          _vm.accessibilityOptionsList,
                          function (a11y) {
                            return _c("KCheckbox", {
                              key: "a11y-" + a11y.value,
                              attrs: {
                                checked: _vm.isSelected(
                                  "accessibility_labels",
                                  a11y
                                ),
                                disabled: a11y.disabled,
                                label: a11y.label,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChange(
                                    "accessibility_labels",
                                    a11y
                                  )
                                },
                              },
                            })
                          }
                        )
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1263606039
                ),
              })
            : _vm._e(),
          _c("AccordionItem", {
            staticClass: "accordion-select",
            style: _vm.accordionItemStyles,
            attrs: {
              title: _vm.coreString("showResources"),
              headerAppearanceOverrides: _vm.accordionHeaderStyles(
                _vm.anySelectedFor("learner_needs", _vm.needsOptionsList)
              ),
              disabled:
                _vm.searchLoading ||
                _vm.needsOptionsList.every((opt) => opt.disabled),
              contentAppearanceOverrides: {
                maxHeight: "256px",
                overflowY: "scroll",
              },
            },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function () {
                  return _vm._l(_vm.needsOptionsList, function (need) {
                    return _c("KCheckbox", {
                      key: "resource-need-" + need.value,
                      attrs: {
                        checked: _vm.isSelected("learner_needs", need),
                        disabled: need.disabled,
                        label: need.label,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleChange("learner_needs", need)
                        },
                      },
                    })
                  })
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }